import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'
import { setNemsisCustomConfigGroupOptions } from '../store/options.actions'

export function* getCustomStateConfigGroups() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getStateCustomElementConfigGroups])
    const { entity } = response
    yield put(setNemsisCustomConfigGroupOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getCustomStateConfigGroups() error while fetching state custom elements: ${e}`))
  }
}

export function* getCustomStateConfigGroupsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getCustomStateConfigGroups)
}
